export const articles = { // these keys are support.healthunlocked.com slugs for specific helpscout articles
  '11-community-guidelines': '5cf62b5a04286333a26421db',
  '25-how-do-i-mute-a-user-who-is-private-messaging-me': '5cf643aa2c7d3a383713123a',
  '36-turn-off-replying-on-posts': '5cf64a992c7d3a38371312b5',
  '37-how-do-i-add-google-analytics-tracking-to-my-community': '5cf64c6604286333a26423ca',
  '38-how-do-i-create-or-edit-a-badge': '5cf64d3f2c7d3a38371312db',
  '39-what-does-following-a-community-mean': '5c8adbf70428633d2cf39e85',
  '42-community-campaigns': '5cf6514704286333a26423fe',
  '44-health-needs-assessment': '5cf652532c7d3a3837131320',
  '55-what-happens-when-i-remove-a-post': '5cfe76ae04286333a2646149',
  '71-why-am-i-being-asked-to-sign-in-every-time-i-access-healthunlocked': '5cfe7f292c7d3a38371353ef',
  '101-your-profile-on-healthunlocked': '5d4c52882c7d3a036965cdbd',
  '102-sentiment-feedback': '5d5c02392c7d3a7920be4421',
  '107-what-happens-when-i-report': '5dc5463b04286364bc9181e2',
  '109-why-my-youtube-video-is-not-playing': '5e6270082c7d3a7e9ae8cb6e',
  '118-explore-recommendations': '5e6b99db2c7d3a7e9ae92565',
  '119-what-is-the-people-near-me': '5e74a7c904286364bc96fef8',
  '120-sentiment-filter': '5e79ce5404286364bc9722d0',
  '131-formatting-your-about-page-community-description-using-markdown': '5ee244fc2c7d3a10cba8c34d',
  '134-community-description': '5f0ce0c12c7d3a10cbaa8fe0',
  '142-images-hidden-by-default': '5f87485e4cedfd0017dd1c4b',
  '147-terms': '60241fa9a4cefb30ae5c9902',
  '148-privacy': '602422356867724dfc6f1d7c',
  '149-terms-for-affiliates': '6024252dac2f834ec538791f',
  '150-cookies': '602428a8a4cefb30ae5c9950',
  '151-security': '60245eb4ac2f834ec5387b3c',
  '153-updates-to-privacy-policy-and-term-of-use': '602a86408502d1120e9077d8',
  '154-opportunities-by-email': '602bb51a8502d1120e907d8c',
};

export const useHelpScout = (article, options) => window.HelpscoutBeacon.triggerHelpScoutArticle(article, options);
export const useHelpScoutBeacon = () => window.HelpscoutBeacon.triggerHelpScoutBeacon();



// WEBPACK FOOTER //
// ./app/assets/js/utils/helpScout.js